import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ENVIRONMENT_CONFIG } from 'constants/environment';
import { TEXT_PROMO_DISMISSED_KEY } from 'constants/notification-bar';
import { TopBarNotificationType } from 'constants/notifications';
import { Permission } from 'constants/permission';
import { useTextPromoEligibility } from 'hooks/use-text-promo-eligibility';
import { getItem, saveItem } from 'services/session-storage';
import { getLoggedInAgentRole } from 'store/entities/agents/selectors';
import { NotificationsBarActions } from 'store/features/notifications-bar/actions';

export function useTextPromoBar(): () => void {
  const dispatch = useDispatch();
  const isEligible = useTextPromoEligibility();
  const role = useSelector(getLoggedInAgentRole);
  const [isDismissed, setIsDismissed] = useState(() => Boolean(getItem<boolean>(TEXT_PROMO_DISMISSED_KEY)));
  const shouldShow =
    isEligible &&
    (role === Permission.Owner || role === Permission.Administrator) &&
    !isDismissed &&
    !ENVIRONMENT_CONFIG.arePromotionalCampaignsDisabled;

  useEffect(() => {
    if (!shouldShow) {
      return;
    }

    dispatch(NotificationsBarActions.showNotificationsBar({ name: TopBarNotificationType.TextPromo }));

    return () => {
      dispatch(NotificationsBarActions.hideNotificationsBar(TopBarNotificationType.TextPromo));
    };
  }, [dispatch, shouldShow]);

  return useCallback(() => {
    saveItem(TEXT_PROMO_DISMISSED_KEY, true);
    setIsDismissed(true);
  }, []);
}
